import React from "react";
import cpImg from "../Assets/img/course/Rectangle 1009.png";
import pbImg from "../Assets/img/course/Rectangle 1012.png";
import dsImg from "../Assets/img/course/Rectangle 1011.png";
import wdImg from "../Assets/img/course/Rectangle 1010.png";
import { Link } from "react-router-dom";
import "./course.css";
function cProgrammingMobile() {
	let array = [
		{
			name: "Competitive Programming",
			linkTo: "/cpcourse",
			imgSrc: cpImg,
		},
		{
			name: "Get Placement Ready",
			linkTo: "/placementcourse",
			imgSrc: pbImg,
		},
		{
			name: "Web Development",
			linkTo: "Na",
			imgSrc: wdImg,
		},
		{
			name: "Data Science",
			linkTo: "Na",
			imgSrc: dsImg,
		},
	];
	return (
		<div>
			<div style={{ textAlign: "center" }} className="my-3">
				<h3 style={{ fontWeight: "900" }}>Our Courses</h3>
			</div>
			{console.log(array)}
			<div className="container-fluid for-mobile-ourCourse-J">
				{array.map((item) => (
					<div className="gray-mobile-ourCourse-J">
						<div className="row justify-content-center mobile-ourCourse-J my-4 ">
							<div className="col-md-3 col-sm-7 col-6 mx-1 pt-4">
								<h5>{item.name}</h5>
								{item.linkTo === "Na" ? (
									<p
										style={{
											color: "grey",
											fontSize: "15px",
										}}
									>
										Coming Soon...
									</p>
								) : (
									<Link to={item.linkTo}>
										<button className="btn ourCourse-exploreBtn-J p-1 my-2">
											Explore
										</button>
									</Link>
								)}
								<p className="blue-mobile-ourCourse-text-J">
									7 day Money back Guarantee
								</p>
							</div>
							<div className="col-md-3 col-sm-4 col-4 mx-1 py-2">
								<img width="120%" src={item.imgSrc} alt="" />
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default cProgrammingMobile;
